var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetcity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 4,
    viewBox: "0 0 28 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1030_4030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03584 0.0526123H8.04695L7.90853 0.877519H5.9184L5.84919 1.3514H7.04325L6.90481 2.19386H5.71074L5.62421 2.75549H7.822L7.68355 3.63305H4.46475L5.03584 0.0526123Z",
    fill: "#0092F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56985 0.947752H8.30655L8.445 0.0701904H11.9926L11.8541 0.947752H10.5909L10.1755 3.65064H9.17182L9.56985 0.947752Z",
    fill: "#0092F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0618 2.03594C12.0272 0.86001 12.8232 0 13.9135 0C15.1767 0 15.5575 0.86001 15.5921 1.28124H14.5711C14.5192 1.19348 14.3461 0.930216 13.9481 0.930216C13.377 0.930216 13.0655 1.42165 13.0828 1.98329C13.1001 2.43962 13.3597 2.79064 13.7923 2.79064C14.2077 2.79064 14.3807 2.54492 14.4326 2.45717H15.4536C15.3844 2.7731 14.9691 3.70331 13.8269 3.70331C12.7886 3.70331 12.0964 3.01882 12.0618 2.03594Z",
    fill: "#0092F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3362 0.0526123H17.3399L16.9938 2.21141L18.8974 0.0526123H19.9011L19.3473 3.63305H18.3436L18.6897 1.47426L16.7862 3.65062H15.7824L16.3362 0.0526123Z",
    fill: "#0092F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5278 0.947752H20.2645L20.403 0.0701904H23.9506L23.8121 0.947752H22.5488L22.1335 3.65064H21.1125L21.5278 0.947752Z",
    fill: "#0092F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4351 0.0526123H25.4387L25.0927 2.21141L26.9964 0.0526123H28L27.4463 3.63305H26.4426L26.7887 1.47426L24.885 3.63305H23.8813L24.4351 0.0526123Z",
    fill: "#0092F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71693 1.3865H1.81706L1.88628 0.947725H4.01483L4.15328 0.0526123H1.02101L0.813349 1.3865H0.121137L0 2.19386H0.674908L0.449939 3.63305H2.54387C3.51299 3.63305 4.17057 3.19429 4.13597 2.33427C4.11865 1.73753 3.6168 1.3865 2.71693 1.3865ZM2.6304 2.75549H1.59209L1.67862 2.19386H2.73424C2.9419 2.19386 3.04574 2.26406 3.06303 2.40448C3.08035 2.63263 2.9073 2.75549 2.6304 2.75549Z",
    fill: "#0092F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1030_4030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 3.70331,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetcity);
export default __webpack_public_path__ + "static/media/betcity.de2c9b3c540f873c4431c5628123f12f.svg";
export { ForwardRef as ReactComponent };